import router from '@/router'
import { defineStore } from 'pinia';
import { strUtil } from '@/utils'

export const useBaseStore = defineStore('base', {
  state: () => ({
    language: {}, 
    managerCd:"",
    managerInfo: {},
    qrInfo: "",
  }),
  getters: {
    getLanguage: (state) => state.language,
    getManagerCd: (state) => state.managerCd,
    getManagerInfo: (state) => state.managerInfo,
    getQrInfo: (state) => state.qrInfo,
  },
  actions: {
    setLanguage(language) {
      this.$state.language = language
    },
    setManagerCd(managerCd) {
      this.$state.managerCd = managerCd
    },
    setManagerInfo(managerInfo) {
      this.$state.managerInfo = managerInfo
    },
    setQrInfo(qrInfo) {
      this.$state.qrInfo = qrInfo
    },
    goRouter(path) {
      if (!strUtil.isEmpty(path)) {
        router.push(path)
      } else {
        alert("준비중입니다.")
      }
    },
    go_back() {
      router.go(-1)
    },
    goLogout() {
      this.$state.managerCd = ""
      this.$state.managerInfo = {}
      this.$state.qrInfo = ""
      router.push('/')
    },
    
  },
  persist: {
    enabled: true, // 전체 state 저장 활성화
    storage: sessionStorage, // sessionStorage 사용
  },
})
